import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Button, Paper } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

const PaymentCancel = () => {
  const navigate = useNavigate();

  const handleTryAgain = () => {
    navigate('/subscription');
  };

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ p: 4, mt: 8, borderRadius: 2 }}>
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          textAlign: 'center'
        }}>
          <CancelIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
          <Typography variant="h4" gutterBottom>
            Payment Cancelled
          </Typography>
          <Typography variant="body1" paragraph>
            Your payment process was cancelled. No charges have been made to your account.
          </Typography>
          <Typography variant="body1" paragraph>
            You can try again or continue using LeaveWise with your current plan.
          </Typography>
          
          <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleTryAgain}
            >
              Try Again
            </Button>
            <Button 
              variant="outlined" 
              color="primary" 
              onClick={handleGoToDashboard}
            >
              Go to Dashboard
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default PaymentCancel;
